export const LOCALES = {
  en: 'en',
  es: 'es',
}

export const LOCALE_OPTIONS = [
  { value: LOCALES.en, label: 'English' },
  { value: LOCALES.es, label: 'Español' },
]
